<div class="sb-outline-container">
    <state-builder-outline [(selectedState)]="_state" [(currentPage)]="currentPage" (setCurrentPage)="setCurrentPage($event)"
        (addRuleEvent)="addRulesEditorHandler()" (editSectionValidationEvent)="editSectionValidationHandler($event)" (goToDiagram)="goToDiagram($event)" data-sticky-container></state-builder-outline>
</div>
<div cdkDropListGroup>
    <div class="sb-dnd-container">
        <state-builder-dnd></state-builder-dnd>
    </div>
    <div class="sb-page-container">
        <state-builder-page [(currentPage)]="currentPage" [(selectedState)]="_state" [activeTemplate]="template" (selectedQuestionEvent)="setSelectedQuestionHandler($event)"
            (showRulesEvent)="showButtonRulesEditorHandler($event)" (openSettingsEvent)="openSettings($event)">
        </state-builder-page>
    </div>
</div>
